<template>

    <div class="page_content module_course" aria-label="Release Logic Page Content" v-if="permission && permission.version === '5'">

        <course-header :course-id="course.uuid" class="header_course_dashboard"></course-header>

        <div class="page-content">

          <div class="pg_fld_sec">
            <div class="row" style="padding: 0 0 0 42px;">
              <div class="col-12 section_head ace_sec_hd">
                Release Logic of of Micro Competencies for the Whole Course
              </div>
            </div>
          </div>

          <!-- Edit Logic  -->
          <template v-if="microCompetencyReleaseLogicTypeDB==0">
            <div class="page-section pg_fld_sec" style="padding: 20px 0 0 0;">

              <div class="row">
                <div class="col-12 page_content_block list_container_radio">

                  <div class="row fld_row">
                    <div class="col-1 fld_input fld_radio">
                      <input type="radio" name="microCompetencyReleaseLogicType" id="one" value="0" v-model="microCompetencyReleaseLogicType">
                    </div>
                    <div class="col-11">
                      <label>
                        All Micro Competencies are unlocked
                      </label>
                    </div>
                  </div>

                  <div class="row fld_row">
                    <div class="col-1 fld_input fld_radio">
                      <input type="radio" name="microCompetencyReleaseLogicType" id="one" value="1" v-model="microCompetencyReleaseLogicType">
                    </div>
                    <div class="col-11">
                      <label>
                        All Micro Competencies are locked (instructor manually unlocked for all enrolled users)
                      </label>
                    </div>
                  </div>

                  <div class="row fld_row">
                    <div class="col-1 fld_input fld_radio">
                      <input type="radio" name="microCompetencyReleaseLogicType" id="one" value="2" v-model="microCompetencyReleaseLogicType">
                    </div>
                    <div class="col-11">
                      <div class="float-left">
                        <label>
                          All Micro Competencies are unlocked on this date
                        </label>
                      </div>
                      <div class="float-left pl-3">
                        <div class="datepicker-wrapper">
                          <span class="datepicker-icon ic_dateRange"></span>
                          <datepicker
                            id="unlockDate"
                            v-model="unlockDate"
                            name="uniquename"
                            aria-describedby="unlockDateFeedback"
                            :disabledDates="disabledDates">
                          </datepicker>
                        </div>
                      </div>
                      <div class="float-left">
                        <b-form-invalid-feedback id="unlockDateFeedback">
                          Unlock Date can not be empty, Please select!
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                  </div>

                  <div class="row fld_row">
                    <div class="col-1 fld_input fld_radio">
                      <input type="radio" name="microCompetencyReleaseLogicType" id="one" value="3" v-model="microCompetencyReleaseLogicType">
                    </div>
                    <div class="col-11">
                      <label>
                        All Micro Competencies are unlocked upon completion of Diagnostic Test
                      </label>
                    </div>
                  </div>

                  <div class="row fld_row">
                    <div class="col-1 fld_input fld_radio">
                      <input type="radio" name="microCompetencyReleaseLogicType" id="one" value="4" v-model="microCompetencyReleaseLogicType">
                    </div>
                    <div class="col-11">
                      <label>
                        All Micro Competencies are unlocked upon completion of previous Competency
                      </label>
                    </div>
                  </div>

                  <div class="row fld_row">
                    <div class="col-1 fld_input fld_radio">
                      <input type="radio" name="microCompetencyReleaseLogicType" id="one" value="5" v-model="microCompetencyReleaseLogicType">
                    </div>
                    <div class="col-11">
                      <label>
                        All Micro Competencies are unlocked upon completion of previous Micro Competency
                      </label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 btn-container" style="text-align: right;">
                      <button class="btn btn-primary" @click="save" aria-label="save">save</button>
                      <button class="btn btn-primary" @click="cancel" aria-label="save">cancel</button>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </template>

      <template v-else>
        <div class="page-section pg_fld_sec">
          <div class="page_section_row description min-content">

            <div class="value page_content_block">
              <div class="row">
                <div class="col-12">
                  <div class="row fld_row">
                    <div class="col-11">
                      <label v-if="microCompetencyReleaseLogicType==1">
                        All Micro Competencies are locked (instructor manually unlocked for all enrolled users)
                      </label>
                      <label v-if="microCompetencyReleaseLogicType==2">
                        All Micro Competencies unlock on {{unlockDate}}
                      </label>
                      <label v-if="microCompetencyReleaseLogicType==3">
                        All Micro Competencies are unlocked upon completion of Diagnostic Test
                      </label>
                      <label v-if="microCompetencyReleaseLogicType==4">
                        All Micro Competencies are unlocked upon completion of previous Competency
                      </label>
                      <label v-if="microCompetencyReleaseLogicType==5">
                        All Micro Competencies are unlocked upon completion of previous Micro Competency
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
</template>
 <!-- End Edit Logic -->
            </div>
        </div>



   </div>

</template>

<script>
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import Datepicker from 'vuejs-datepicker'

var DisableDate = function () {
  const date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}
export default {
  name: 'releaseLogic',
  props: ['uuid'],
  components: {
    CourseNav,
    CourseHeader,
    Datepicker
  },

  data: () => {
    return {
        microCompetencyReleaseLogicType : 0,
        microCompetencyReleaseLogicTypeDB:-1,
        unlockDate:undefined,
        disabledDates: {
          to: new DisableDate()
        },
        months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],

    }
  },

  mounted () {
    this.loadPermission().then(res => {
      this.loadCourseDetailFromServer(this.uuid).then(res => {
        this.microCompetencyReleaseLogicType = res.microCompetencyReleaseLogicType
        this.unlockDate = res.microCompetencyReleaseDate
        this.microCompetencyReleaseLogicTypeDB = res.microCompetencyReleaseLogicType
        })
    })
  },


  methods: {
    ...mapActions([
      'loadCourseDetailFromServer',
      'loadPermission',
      'addReleaseLogic'
    ]),

    save () {
        let unlockDateStr=undefined
        if(this.microCompetencyReleaseLogicType==2){
          if(this.unlockDate){
            unlockDateStr = this.changeDateToString(this.unlockDate)
            $('#unlockDateFeedback').hide()
          }else{
            $('#unlockDateFeedback').show()
            return
          }
        }
        this.addReleaseLogic({courseId:this.course.uuid, type:this.microCompetencyReleaseLogicType, unlockDate:unlockDateStr}).then(res => {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Micro Competency Release Logic updated successfully.'
            })
            return this.$router.push({ name: 'courseDashboardInstructor', params: { uuid: this.course.uuid } })
        })
    },
    cancel () {
        return this.$router.push({ name: 'courseDashboardInstructor', params: { uuid: this.course.uuid } })
    },
    changeDateToString (selected) {
      if (selected) {
        const date = new Date(selected)
        let mm = String(this.months[date.getMonth()])
        let dd = date.getDate()
        if (dd < 10) {
          dd = '0' + dd
        }
        let yyyy = date.getFullYear()
        let formatted = mm +'-'+ dd +'-'+ yyyy
        return formatted
      }
      return undefined
    },

    changeDateFormat (selected) {
      if (selected && selected.length > 0) {
        const mm = selected.slice(0, 2)
        const dd = selected.slice(2, 4)
        const yyyy = selected.slice(4)
        return mm + '/' + dd + '/' + yyyy
      }
      return selected
    }


  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'permission': state => state.user.permission
    })
  }
}
</script>

<style scoped>
.course-nav {
    background:#e1e1e1;
    min-height: 500px;
}
.coure-nav-list-item {
    background:#e1e1e1;
    border: none;
}

.course-thumbnail {
    background:#f8f9fa;
    min-height: 500px;
}

.course-information {
    margin-top:20px;
}

.course-description {
    padding-top:20px;
}

.activity-row {
    padding-top:20px;
}

.card {
    border: none!important;
}

.card-header {
    background: rgb(245, 245, 245) !important;
}

.card-body {
    background: rgb(245, 245, 245) !important;
}

.report-Page .heading {
    padding: 7px 7px 7px 7px;
    border-bottom: 1px solid #efefef;
    font-size: 20px;
    font-family: robotoSlab_Light;
    margin-bottom:15px;
}
.report-Page {
    padding-top:18px;
}
.report-Page .activity-graph-container {
    border: 1px solid #dbdbdb!important;
    border-radius: 0;
    min-height: 270px;
    font-family: openSans_Regular;
}

.report-Page .label {
    background: #c9e0b2;
    padding: 8px;
    color: #4d4d4d;
    font-size: 19px;
}

.report-Page .graph-area {
    height: 228px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.graph-min-height {
    min-height:251px!important;
}

.report-Page .graph-text {
    text-align: center;
    color: #4d4d4d;
    position: relative;
    top: -42px;
}
.report-Page .dashboard-row {
    min-width:1115px;
    padding-left:15px;
}
.report-Page .left-space {
    padding-left:100px;
}
.report-section {
    height: auto;
    padding-left: 15px;
}

.report-graph {
    flex: 0 0 30%!important;
    max-width: 30%!important;
}

.competency-details-row {
    padding-left:33px;
    height: auto;
}

.competency-details-row .value, .competency-details-row .title {
    width: 100%;
    float: left;
    padding: 8px 8px;
}

.score-column {
    width: 30%;
    display: none;
    margin-top: 15px;
}

.column.progress-column {
    position: relative !important;
    display: none;
    margin-top: 9px;
    padding-top: 0!important;
    padding-bottom: 0!important;
    padding-left: 10px!important;
}

.time-column {
    width: 30%;
    display: none;
}

.column.time-column, .column.resource-time-column {
   height: 44px;
   padding: 0!important;
   display: flex;
   align-items: center;
   justify-content: center;
   margin-top: 9px;
   background: none;
}

.time-value-box {
    padding:10px 15px;
    background:rgb(143, 143, 143);
    color:#fff;
	width:96px;
	text-align:center;
}

.last-activity-value-box {
    padding: 5px 8px;
    background: #8f8f8f;
    color: #fff;
    position: absolute;
    font-size: 12px;
    top: 9px;
    height: 44px;
    width: 94px;
    margin: auto;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.resource-time-column {
    position:relative;
    display: none;
}

.last-activity-column {
    position:relative;
    display: none;
}

.competency_progress {
    width:100%;
    position:static;
}

.table thead {
    background: #f5f5f5;
}

.report-column {
	height:calc(100vh - 290px);
	overflow-y: hidden;
	overflow-x: hidden;
}

.breadcrumb-item {
	max-width: 195px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
@media (max-width: 1024px) {
	.report-column {
		overflow-y:auto;
	}
}

button.attempt-report-close {
    border: 0;
    background: transparent;
    padding: 15px;
    margin: -15px -15px -15px auto;
    cursor: pointer;
    -webkit-appearance: none;
}

.attempt-report-close {
    float: right;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}


</style>



// WEBPACK FOOTER //
// src/app/course/components/ReleaseLogic.vue